<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-bullhorn"></i> Gestão de Campanhas <span v-if="showReport">| {{ campaignName }}</span></h3>
        <small v-if="showReport">Visualize os resultados da sua campanhas de forma objetiva.</small>
        <small v-else>Crie campanhas para obter novos clientes ou oferecer novas oportunidades de negócio.</small>
      </div>
    </div>
    <CampaignAdd v-if="showAdd" ref="CampaignAdd" v-on:Back="onBack" />
    <CampaignReport v-else-if="showReport" ref="CampaignReport" v-on:Back="onBack" />
    <CampaignList v-else ref="CampaignList" v-on:New="onNew" v-on:Edit="onEdit" v-on:Report="onReport"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import CampaignAdd from './components/add/campaignadd.vue'
import CampaignList from './components/list/campainglist.vue'
import CampaignReport from './components/report/report.vue'

export default {
  name: 'Campaign',
  data () {
    return {
      showAdd: false,
      showReport: false,
      campaignName: null
    }
  },
  components: {
    CampaignAdd,
    CampaignList,
    CampaignReport
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  mounted () {
    Tools.MinimizedSidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
      this.showReport = false
    },
    onReport (obj) {
      this.showAdd = false
      this.showReport = true
      this.$nextTick(() => {
        this.$refs.CampaignReport.onEdit(obj)
        this.campaignName = obj.nome
      })
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.CampaignAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
      this.showReport = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/campaign/campaign.vue